import React from 'react';
import PropTypes from 'prop-types';
import { inject } from 'mobx-react';
import { PiSparkleFill } from 'react-icons/pi';
import { additionalAlertTroubleshootingContext } from '@kentik/ui-shared/kaizen/constants';
import { AiContext, Button } from 'core/components';
import storeLoader from 'app/stores/storeLoader';

const AlertAiAdvisorButton = ({ policy, alertModel, buttonProps, $journeys, $auth, $runbook }) => {
  const { canUseAiTools } = $auth;
  const hasJourneysV2 = $auth.hasPermission('kaizen', { overrideForSudo: false });

  if (!canUseAiTools || !hasJourneysV2 || !policy || !alertModel) {
    return null;
  }

  const runbooks = $runbook.getRunbooksForPolicy(policy);

  const alertContextAndSuggestions = () => {
    const fullAlertDetails = alertModel.get();

    delete fullAlertDetails.policy; // avoid circular reference in the context

    return {
      model: fullAlertDetails,
      name: `Alert Details: ${policy.name}`,
      placeholder: 'Ask anything about this alert',
      context: `Alert details for ${policy.name}\n
				Description: ${policy.description}\n
				Policy Dimensions: ${policy.dimensions.join(', ')}\n
				Policy Filters: ${JSON.stringify(policy.filters)}\n
				Policy Selected Devices: ${JSON.stringify(policy.devices)}\n
				Policy Primary Metric: ${policy.metrics.join(', ')}\n
				Dimensions: ${JSON.stringify(alertModel.dimensions, null, 2)}\n
				Full alert details: ${JSON.stringify(fullAlertDetails, null, 2)}\n
				${runbooks.length ? '' : additionalAlertTroubleshootingContext}`,
      suggestions: ['Troubleshoot this alert for me'],
      type: 'alert'
    };
  };

  return (
    <>
      <Button
        icon={PiSparkleFill}
        textAlign="left"
        {...buttonProps}
        onClick={() => {
          $journeys.openCopilot({ isHalfScreen: true });
          $journeys.sendMessage('Troubleshoot this alert for me', { createNewJourney: true });
        }}
      >
        Investigate with AI Advisor
      </Button>
      <AiContext type="alert" {...alertContextAndSuggestions()} />
      {runbooks.map((runbook) => (
        <AiContext key={runbook.get('id')} type="runbook" name={runbook.get('name')} context={runbook.toString()} />
      ))}
    </>
  );
};

AlertAiAdvisorButton.propTypes = {
  policy: PropTypes.object,
  alertModel: PropTypes.object,
  buttonProps: PropTypes.object,
  isSubtenant: PropTypes.bool,
  $journeys: PropTypes.object.isRequired,
  $auth: PropTypes.object.isRequired,
  $companySettings: PropTypes.object.isRequired,
  $runbook: PropTypes.object.isRequired
};

AlertAiAdvisorButton.defaultProps = {
  policy: null,
  alertModel: null,
  buttonProps: {},
  isSubtenant: false
};

export default inject('$journeys', '$auth', '$companySettings')(storeLoader('$runbook')(AlertAiAdvisorButton));
